import { render, staticRenderFns } from "./ActionsDropdownItem.vue?vue&type=template&id=47e158a4&"
import script from "./ActionsDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./ActionsDropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./ActionsDropdownItem.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports